import { useContext } from 'react';
import { chatContext, ChatContext } from "./chatContext";

export const useChat = (): ChatContext => {
  return useContext(chatContext);
};